<div class="picklist-virtual-calculator-form">
  <lum-ui-virtual-calculator
    (valueChangeEmit)="onValueChange($event)"
  ></lum-ui-virtual-calculator>

  <mat-dialog-actions align="end">
    <button
      type="button"
      class="lum-button lum-button--tertiary mr-2"
      mat-button
      mat-dialog-close
    >
      Close
    </button>
    <button (click)="onSave()" mat-button class="lum-button">Save</button>
  </mat-dialog-actions>
</div>
